<template>
    <div class="about mt-4">
        <div class="mb-4">
            <img src="https://www.magico.pl/files/MaterialyDoPobrania/logo_magico_png_whitebackgroung_min.png"
                alt="Agencja Kreatywna Magico" width="200">
        </div>
        <h2>Wniosek urlopowy</h2>
        <div class="form-group text-start mb-2">
            <label>Początek urlopu</label>
            <DatePicker v-model="start" type="date" value-type="YYYY-MM-DD" format="YYYY-MM-DD" class="d-block w-100" input-class="form-control"></DatePicker>
        </div>
        <div class="form-group text-start mb-2">
            <label>Koniec urlopu</label>
            <DatePicker v-model="stop" type="date" value-type="YYYY-MM-DD" format="YYYY-MM-DD" class="d-block w-100" input-class="form-control"></DatePicker>
        </div>
        <div class="form-group text-start mb-2">
            <label>Powód</label>
            <select class="form-select">

            </select>
        </div>
        <div class="form-group text-start mb-2">
            <label>Dodatkowe informacje</label>
            <textarea v-model="info" class="form-control">

            </textarea>
        </div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: {
        DatePicker
    },
    data: function () {
        return {
            start: '',
            stop: '',
            reason: '',
            info: '',
        }
    }
}
</script>